import React from "react";
import {IonItem, IonList} from "@ionic/react";
import {IFormItems, IFormProps} from "../../component/form/model/FormModel";
import BasicForm from "../../component/form/BasicForm";
import AppButton from "../../element/button/AppButton";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import ApiResponseVO from "../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../ts/manager/Manager";
import {IAnyObject} from "../../../ts/common/SimpleInterface";
import InputFIE from "../../component/form/form-item-element/InputFIE";
import AlertFE from "../../component/form/form-element/AlertFE";
import PasswordInputFIE from "../../component/form/form-item-element/PasswordInputFIE";

interface IProps extends IFormProps
{
    setLoginState?: React.Dispatch<React.SetStateAction<string>>;
}

export class AccountLoginForm extends BasicForm
{
    props: IProps;

    showResetPassword: boolean = false;
    passwordResetButton: React.JSX.Element | null = null;

    debugUserName = "";
    debugPassword = "";

    constructor(props: IProps)
    {
        super(props);

        this.props = props;
    }

    applyDebugValues()
    {
        super.applyDebugValues();
    }

    initVariables()
    {
        super.initVariables();

        if (this.props.setLoginState)
        {
            const setLoginState: React.Dispatch<React.SetStateAction<string>> = this.props.setLoginState;
            this.passwordResetButton =
                <AppButton className="anchor" nonButton={true} onClick={() => setLoginState("password_reset")}>Lost your password</AppButton>;
        } else
        {
            const accountModel = getModelFactory().accountRoute.getDefaultModel();
            const passwordResetChoice: RouteChoice | null = accountModel.choices.password_reset ?? null;
            if (passwordResetChoice)
            {
                this.passwordResetButton =
                    <RouteChoiceButton routeChoice={passwordResetChoice}>Lost your password</RouteChoiceButton>;
            }
        }
    }

    customError(responseVO: ApiResponseVO): boolean
    {
        if (["invalid_username", "incorrect_password"].includes(responseVO.apiError?.code ?? ""))
        {
            this.showResetPassword = true;
            return true;
        }
        return super.customError(responseVO);
    }

    handleCurrentlyValid()
    {
        super.handleCurrentlyValid();
        this.showResetPassword = false;

    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);

        return await getManager().api.fetchData("/jwt-auth/v1/token", "POST", params);
    }


    async getAdditionalData(responseVO: ApiResponseVO): Promise<void>
    {
        let error: string | null = getManager().user.login(responseVO.data.user, false, responseVO.data.token, true);
        if (error)
        {
            return Promise.reject(error);
        }
        const accessTokens = getManager().user.unregisteredOrganisationAccess;
        if (!Object.keys(accessTokens).length)
        {
            getManager().user.handleUserLogInOut();
            return;
        }
        const params: IAnyObject = {}
        params.unregistered_access_tokens = accessTokens;
        return await getManager().api.fetchData("/organisation/set_unregistered_access_to_registered", "POST", params, true).then(responseVO =>
        {
            if (responseVO.apiError)
            {
                getManager().user.handleUserLogInOut();
                return Promise.reject(responseVO.apiError);
            }
            getManager().user.removeAllUnregisteredOrganisationAccess();
            getManager().user.handleUserLogInOut();
        })
    }

    renderComponent()
    {

        const {showResetPassword, passwordResetButton} = this;

        return <>

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.startFormAlerts()}

                            {showResetPassword && passwordResetButton &&
                                <AlertFE
                                    elementProps={{
                                        className: "alert-info"
                                    }}
                                >

                            <span>
                                <strong>
                                    ERROR
                                </strong>
                                : Either your username or password is incorrect. {passwordResetButton}?
                            </span>
                                </AlertFE>
                            }
                            {this.requiredFieldsMessage()}

                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "username",
                                            name: "Email Address",
                                            required: true,
                                            errorMessages: {
                                                required: "Please enter your email address"
                                            }
                                        }}
                                        elementProps={{
                                            type: "email"
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <PasswordInputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "password",
                                            name: "Password",
                                            required: true,
                                            errorMessages: {
                                                required: "Please enter your password"
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Login
                                    </AppButton>
                                </div>
                            </div>

                            {this.endFormAlerts()}
                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}